module.exports = __webpack_public_path__ + "static/voice-e5e74169f3abf3dc6010834b1b77eb8e.png";